import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const toggleMenu = () => setIsOpen(!isOpen);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Projects',
    path: '/projects'
  }, {
    name: 'Team',
    path: '/team'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="fixed w-full z-50 transition-all duration-300 bg-[#1a2e1a]" data-id="element-88">
      <div className="container mx-auto px-4 md:px-6 py-4 flex justify-between items-center" data-id="element-89">
        <Link to="/" className="flex items-center" data-id="element-90">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qJ3rr1dXK6fVNoRjx4haL4/s__r_logo-1.png" alt="Socrates and Richard Logo" className="h-12 md:h-14" data-id="element-91" />
          <span className="ml-2 text-lg font-medium text-white" data-id="element-92">
            Socrates & Richard
          </span>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-93">
          {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-[#95c11f] ${location.pathname === link.path ? 'text-[#95c11f]' : 'text-white'}`} data-id="element-94">
              {link.name}
            </Link>)}
        </nav>
        {/* Mobile Navigation Button */}
        <button onClick={toggleMenu} className="md:hidden text-white hover:text-[#95c11f] transition-colors" aria-label="Toggle Menu" data-id="element-95">
          {isOpen ? <XIcon size={24} data-id="element-96" /> : <MenuIcon size={24} data-id="element-97" />}
        </button>
      </div>
      {/* Mobile Navigation Menu */}
      {isOpen && <div className="md:hidden bg-[#1a2e1a] w-full shadow-lg" data-id="element-98">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-99">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-[#95c11f] py-2 ${location.pathname === link.path ? 'text-[#95c11f]' : 'text-white'}`} data-id="element-100">
                {link.name}
              </Link>)}
          </div>
        </div>}
    </header>;
};
export default Navbar;